import { isProduct, isTestnet } from './env';

/**
 * 参考文档：https://uponly.larksuite.com/wiki/OjzgwKJwBisrTbkKHjCumpDvsMg
 *
 * @example
 *  mainnet: 
 *  原始图片：https://s1.bycsi.com/bybit/deadpool/e1b0462fbe6711ed9b80967cb6906def.png
    新地址：https://www.bybit.com/bycsi-root/bybit/deadpool/e1b0462fbe6711ed9b80967cb6906def.png
 */
export const convertS3Url = (url: string) => {
  if (!url) return url;

  if (isProduct) {
    const origin = 'https://s1.bycsi.com/';
    const originCommonStatic = 'https://s1.bycsi.com/common-static/';

    if (url.startsWith(originCommonStatic)) {
      return url.replace(originCommonStatic, '/common-static/');
    }

    if (url.startsWith(origin)) {
      return url.replace(origin, '/bycsi-root/');
    }
  }

  if (isTestnet) {
    const origin = 'https://t1.bycsi.com/';
    const originCommonStatic = 'https://t1.bycsi.com/common-static/';

    if (url.startsWith(originCommonStatic)) {
      return url.replace(originCommonStatic, '/common-static/');
    }

    if (url.startsWith(origin)) {
      return url.replace(origin, '/bycsi-root/');
    }
  }

  return url;
};
